export const LIMIT_GAMES = Object.freeze({
  GLOBAL: "GLOBAL",
  LIVE: "LIVE",
  PREMATCH: "PREMATCH",
});

export const LIMIT_TYPES = Object.freeze({
  MIN_SELECTIONS: "MIN_NUMBER_OF_SELECTIONS",
  MAX_SELECTIONS: "MAX_NUMBER_OF_SELECTIONS",
  MIN_STAKE: "MIN_STAKE",
  MAX_STAKE: "MAX_STAKE",
  MAX_WINNINGS: "MAX_WINNINGS",
  SYSTEM_BANKER_MIN_SELECTIONS: "SYSTEM_BANKER_MIN_NUMBER_OF_SELECTIONS",
  SYSTEM_BANKER_MAX_SELECTIONS: "SYSTEM_BANKER_MAX_NUMBER_OF_SELECTIONS",
  SYSTEM_BANKER_MIN_STAKE: "SYSTEM_BANKER_MIN_STAKE",
  SYSTEM_BANKER_MAX_STAKE: "SYSTEM_BANKER_MAX_STAKE",
  SYSTEM_BANKER_MAX_WINNINGS: "SYSTEM_BANKER_MAX_WINNINGS",
});

export const LIMIT_ATTRIBUTE_TYPES = Object.freeze({
  MAX_NUMBER_OF_SELECTIONS: "MAX_NUMBER_OF_SELECTIONS",
  MIN_NUMBER_OF_SELECTIONS: "MIN_NUMBER_OF_SELECTIONS",
  MAX_BET_STAKE: "MAX_BET_STAKE",
  MIN_BET_STAKE: "MIN_BET_STAKE",
  MAX_BET_WINNINGS: "MAX_BET_WINNINGS",
});
